import React from 'react';
import Spinner from '../../../../../common/components/Spinner';
import './OnboardingPageLoadingIndicator.pcss';

type Props = {
  isLoading: boolean;
};

const OnboardingPageLoadingIndicator = (props: Props) => {
  const { isLoading } = props;

  if (!isLoading) {
    return null;
  }

  return (
    <div className="onboarding-page-loading-indicator">
      <div className="onboarding-page-loading-indicator__blinder" />
      <Spinner
        size={50}
        position="absolute"
        backgroundColor="transparent"
        show={true}
      />
    </div>
  );
};

export default OnboardingPageLoadingIndicator;
